'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _ramda = require('ramda');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _reduxForm = require('redux-form');
var _reactRouter = require('react-router');
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactScroll = require('react-scroll');
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _userAuthentication = require('../../redux/modules/userAuthentication');








var _messageModal = require('../../redux/modules/messageModal');

var _components = require('../../components');

var _containers = require('../../containers');









var _favoriteProperties = require('../../redux/modules/favoriteProperties');



var _propertyDetails = require('../../redux/modules/propertyDetails');
var _propertyNotes = require('../../redux/modules/propertyNotes');

var _constants = require('../../constants');






var _validate = require('../../utils/validate');
var _filterData = require('../../utils/filterData');var _filterData2 = _interopRequireDefault(_filterData);
var _getLoadType = require('../../utils/getLoadType');var _getLoadType2 = _interopRequireDefault(_getLoadType);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _formatPhoneNumber = require('../../utils/formatPhoneNumber');
var _EditProfile = require('../../components/EditProfile/EditProfile.scss');var styles = _interopRequireWildcard(_EditProfile);
var _myAccount = require('../../redux/modules/myAccount');
var _manageProperties = require('../../redux/modules/manageProperties');
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _WhatsAppWidget = require('../../components/WhatsAppWidget/WhatsAppWidget');var _WhatsAppWidget2 = _interopRequireDefault(_WhatsAppWidget);
var _saveSearchLocation = require('../../redux/modules/saveSearchLocation');
var _assetsToDelete = require('../../redux/modules/assetsToDelete');




var _checkers = require('../../utils/checkers');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Redux
// Components
// Containers
// Redux
// Helpers
var selector = (0, _reduxForm.formValueSelector)('editProfileForm');var requiredFields = ['display_name', 'email'];var EditProfilePage = function (_Component) {_inherits(EditProfilePage, _Component);function EditProfilePage() {_classCallCheck(this, EditProfilePage);var _this = _possibleConstructorReturn(this,
    _Component.call(this));_this.




























    componentWillReceiveProps = function (_ref)







    {var initialValues = _ref.initialValues,userData = _ref.userData,isMessageModalOpen = _ref.isMessageModalOpen,currentView = _ref.currentView,phoneNumberVerified = _ref.phoneNumberVerified,routeData = _ref.routeData,userDataError = _ref.userDataError;
      var token = (0, _get2.default)(_this.props, 'initialValues.access_token');
      var newToken = (0, _get2.default)(initialValues, 'access_token');

      if (token !== newToken) {
        _this.props.canCreateStaff(newToken);
      }
      if (initialValues === null && initialValues !== _this.props.initialValues) {
        _this.goHome();
      }
      if (initialValues && _this.props.initialValues && !(0, _isEqual2.default)(initialValues, _this.props.initialValues)) {
        _constants.storage.value.setItem('userData', JSON.stringify(initialValues));
        (0, _analyticsManager.setData)({ dimension1: userData.data.is_agent ? 'realtor' : 'regular' });
      }

      if (phoneNumberVerified && _this.props.phoneNumberVerified !== phoneNumberVerified) {
        _this.cancelRedirect = true;
        _this.openMessageModal(_this.props.translate('editProfile', 'phoneVerified'));
      }

      if (userData && userData.edited && userData.edited !== _this.props.userData.edited && !_this.cancelRedirect) {
        _this.props.changeAssetsTags();
        _this.openMessageModal(_this.props.translate('editProfile', 'profileUpdated'));
      }

      if (!isMessageModalOpen && userData.edited && _this.props.isMessageModalOpen && !_this.cancelRedirect) {
        _this.redirectBack();
      }

      if (currentView === _constants.myAccountViews.FAVORITES) {
        var favoritesLength = (0, _get2.default)(_this.props, 'favoriteProperties.favoriteIDs.length');
        var favoritesLoading = (0, _get2.default)(_this.props, 'favoriteProperties.loading');
        var shouldLoadFavorites = !favoritesLength && !favoritesLoading;

        if (_this.props.currentView !== _constants.myAccountViews.FAVORITES || shouldLoadFavorites) {
          _this.loadFavorites();
        }
      }

      var validViews = Object.values(_constants.myAccountViews);
      if (validViews.includes(routeData.optionType)) {
        _this.props.switchAccountView({ view: routeData.optionType });
      }

      if (userData.data && userData.data.email && (0, _checkers.isTemporaryEmail)(userData.data.email)) {
        _this.props.openAuthenticationModal({ bodyType: _constants.authenticationModalType.UPDATE_TEMPORARY_PROFILE });
      }
      if (userDataError && userDataError !== _this.props.userDataError) {
        if (userDataError.status === _constants.requestErrorStatusCodes.BAD_REQUEST) {
          _constants.storage.value.clear();
          _this.props.openAuthenticationModal({ selectedTab: _constants.userAuthenticationTabs.SIGN_IN });
        }
      }

      if (_this.props.userData.isAuthenticationModalOpen &&
      !userData.isAuthenticationModalOpen && !userData.userIsAuthorized) {
        _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/'));
      }
    };_this.





    getTitleByRoute = function () {
      switch (_this.props.currentView) {
        case _constants.myAccountViews.MY_ACCOUNT:
          return 'myAccount';
        case _constants.myAccountViews.MY_SEARCHES:
          return 'mySearches';
        case _constants.myAccountViews.MY_COMPANY:
          return 'myCompany';
        case _constants.myAccountViews.LEADS:
          return 'leads';
        case _constants.myAccountViews.MY_SUBSCRIPTIONS:
          return 'mySubscriptions';
        default:
          return 'editProfile';}

    };_this.

    logOut = function () {
      _constants.storage.value.clear();
      _this.props.clearUserPropertiesData();
      _this.props.clearFavorites();
      _this.props.clearStoreNotes();
      _this.props.clearSearchData();
      _this.props.logOut();
      (0, _analyticsManager.setData)({ userId: null });
      (0, _analyticsManager.setData)({ dimension1: null });
    };_this.

    openMessageModal = function (messageBody) {return _this.props.openMessageModal({
        message:
        _react2.default.createElement('div', { className: 'contentMessage successMessage' },
          _react2.default.createElement('p', null, messageBody)) });};_this.




    redirectBack = function () {
      if ((0, _getLoadType2.default)() === 'direct') {
        _this.goHome();
      } else {
        _reactRouter.browserHistory.goBack();
      }
    };_this.

    loadFavorites = function () {
      var token = (0, _get2.default)(_this.props, 'userData.data.access_token');

      _this.props.setFavoritesListState(true);
      _this.props.loadFavorites(token);
    };_this.

    handleSwitchView = function (key) {return _this.props.switchAccountView({ view: key });};_this.

    addPropertyNote = function (id, note) {
      var token = (0, _get2.default)(_this.props, 'userData.accessToken');
      _this.props.addPropertyNote({ noteData: { id: id, note: note }, token: token });
    };_this.

    toggleFavorite = function (id) {
      var propertiesData = (0, _get2.default)(_this.props, 'favoriteProperties.favoritesData') || [];
      var token = (0, _get2.default)(_this.props, 'userData.accessToken');
      var property = propertiesData.find(function (item) {return item.id === id;});
      _this.props.toggleFavorite({ property: property, token: token });
    };_this.

    handlePopupOpen = function (preloadData) {return _this.props.openDetailsPopup(Object.assign({},
      preloadData, {
        optionType: _this.props.routeData.optionType }));};_this.


    goHome = function () {return _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/'));};_this.

    addAssetToDelete = function (_ref2) {var publicId = _ref2.publicId,contentType = _ref2.contentType;
      _this.props.addAssetToDelete({ id: publicId, type: contentType });
    };_this.

    openSuccessMessage = function () {
      _this.props.openMessageModal({
        message:
        _react2.default.createElement('div', { className: styles.successPromoted },
          _react2.default.createElement('p', null, _this.props.translate('editProfile', 'formSent')),
          _react2.default.createElement('button', {
              onClick: _this.props.hideMessageModal,
              className: 'btn btn-primary' },

            _this.props.translate('editProfile', 'ok'))) });




    };_this.

    revengeStatePayment = function () {_this.setState({ paymentSuccess: false });};_this.

    handleSuccessPurchasePackage = function (paidProducts, setProcessOverlayState) {
      setProcessOverlayState(false);
      _this.setState(function (state) {return {
          paymentSuccess: true };});

      _this.openSuccessMessage();
    };_this.

    editProfileRequest = function (values) {
      var userData = Object.assign({},
      values, {
        email: values.email.toLowerCase(),
        agent_data: !!values.is_agent && values.agent_data ? {
          license_number: (0, _get2.default)(values, 'agent_data.license_number'),
          company_name: (0, _get2.default)(values, 'agent_data.company_name') } :
        undefined,
        is_agent: !!values.is_agent,
        first_name: values.first_name || null,
        phone_number: values.phone_number ? (0, _formatPhoneNumber.addPhoneCode)(values.phone_number.replace(/\D/g, '')) : null });


      if (!(0, _isEqual2.default)(values, _this.props.userData.data)) {
        var filteredData = (0, _filterData2.default)(_this.props.initialValues, userData);
        var imageLink = (0, _get2.default)(filteredData, 'profile_img.link');

        if (!!imageLink) {
          _this.props.addAssetToUnsuspend({
            type: 'image',
            id: imageLink });

        }

        var data = (0, _omit2.default)(filteredData, ['properties', 'agent_data.verified', 'updated_at']);
        _this.cancelRedirect = false;
        _this.props.editUserProfile({ userData: data, userToken: _this.props.initialValues.access_token });
      }
    };_this.

    renderEditProfile = function () {return (
        _react2.default.createElement(_components.EditProfile, _extends({},
        _this.props, {
          addAssetToDelete: _this.addAssetToDelete,
          handleSubmit: _this.props.handleSubmit(_this.editProfileRequest),
          isMobile: _this.props.isMobile,
          registerNewField: _this.props.registerNewField,
          changeValue: _this.props.changeValue,
          openAuthenticationModal: _this.props.openAuthenticationModal,
          isNative: _this.props.isNative,
          isRealEstate: _this.props.isRealEstate,
          requiredFields: requiredFields,
          resetForm: _this.props.reset,
          logOut: _this.logOut,
          formIsDirty: _this.props.dirty,
          updateVerification: _this.props.updateVerification })));};_this.



    renderDesktopPage = function () {var _cx;return (
        _react2.default.createElement(_components.OMTabs, {
            defaultActiveTabKey: _this.props.currentView,
            onSelect: _this.handleSwitchView,
            className: (0, _classnames2.default)(
            'editProfileTabs',
            'userAuthenticationTabs', (_cx = {}, _cx[

            styles.mySearchesContent] = _this.props.currentView === _constants.myAccountViews.MY_SEARCHES, _cx[
            styles.leadsContent] = _this.props.currentView === _constants.myAccountViews.LEADS, _cx[
            styles.mySubscriptionsContent] = _this.props.currentView === _constants.myAccountViews.MY_SUBSCRIPTIONS, _cx)),


            locale: _this.props.locale,
            routeData: _this.props.routeData,
            withLink: true },

          _react2.default.createElement(_components.OMTab, { id: _constants.myAccountViews.MY_ACCOUNT, title: '' + _this.props.translate('editProfile', 'myAccount') },
            _this.renderEditProfile()),

          _react2.default.createElement(_components.OMTab, { id: _constants.myAccountViews.MY_SEARCHES, title: '' + _this.props.translate('editProfile', 'mySearches') },
            _react2.default.createElement(_containers.SavedSearches, { withoutTitle: true })),

          !(0, _get2.default)(_this.props, 'userData.data.assigned_to_agency_id') &&
          _react2.default.createElement(_components.OMTab, { id: _constants.myAccountViews.MY_COMPANY, title: '' + _this.props.translate('editProfile', 'myCompany') },
            _react2.default.createElement(_containers.EditCompanyByOwner, null)),


          (0, _get2.default)(_this.props, 'userData.data.assigned_to_agency_id') &&
          _react2.default.createElement(_components.OMTab, { id: _constants.myAccountViews.REALTOR_PAGE, title: '' + _this.props.translate('userStaff', 'realtorPage') },
            _react2.default.createElement(_containers.EditUserStaff, null)),


          _this.props.isCanCreateStaff &&
          _react2.default.createElement(_components.OMTab, { id: _constants.myAccountViews.MY_STAFF, title: '' + _this.props.translate('myStaff', 'title') },
            _react2.default.createElement(_containers.MyStaffContainer, null)),


          _react2.default.createElement(_components.OMTab, { id: _constants.myAccountViews.LEADS, title: '' + _this.props.translate('editProfile', 'leads') },
            _react2.default.createElement(_containers.LeadsContainer, {
              withoutTitle: true,
              revengeStatePayment: _this.revengeStatePayment,
              paymentSuccess: _this.state.paymentSuccess,
              routeData: _this.props.routeData,
              location: _this.props.location,
              handlePurchase: _this.handleSuccessPurchasePackage })),


          _react2.default.createElement(_components.OMTab, { id: _constants.myAccountViews.MY_PROJECTS, title: '' + _this.props.translate('editProfile', 'my_projects') },
            _react2.default.createElement(_containers.MyProjects, null)),

          _react2.default.createElement(_components.OMTab, { id: _constants.myAccountViews.MY_SUBSCRIPTIONS, title: '' + _this.props.translate('editProfile', 'mySubscriptions') },
            _react2.default.createElement(_containers.SubscriptionsContainer, { withoutTitle: true }))));};_this.















    renderMobilePage = function () {
      switch (_this.props.currentView) {
        case !_this.props.isCanCreateStaff:return _this.renderEditProfile();
        case _constants.myAccountViews.MY_ACCOUNT:return _this.renderEditProfile();
        case _constants.myAccountViews.MY_SEARCHES:return _react2.default.createElement(_containers.SavedSearches, null);
        case _constants.myAccountViews.MY_COMPANY:return _react2.default.createElement(_containers.EditCompanyByOwner, null);
        case _constants.myAccountViews.MY_STAFF:return _react2.default.createElement(_containers.MyStaffContainer, null);
        case _constants.myAccountViews.REALTOR_PAGE:return _react2.default.createElement(_containers.EditUserStaff, null);
        case _constants.myAccountViews.LEADS:return (
            _react2.default.createElement(_containers.LeadsContainer, {
              revengeStatePayment: _this.revengeStatePayment,
              location: _this.props.location,
              paymentSuccess: _this.state.paymentSuccess,
              routeData: _this.props.routeData,
              handlePurchase: _this.handleSuccessPurchasePackage }));


        case _constants.myAccountViews.MY_PROJECTS:return _react2.default.createElement(_containers.MyProjects, null);
        case _constants.myAccountViews.MY_SUBSCRIPTIONS:return _react2.default.createElement(_containers.SubscriptionsContainer, null);
        default:return _this.renderEditProfile();}

    };_this.state = { paymentSuccess: false };return _this;}EditProfilePage.prototype.componentWillMount = function componentWillMount() {var view = this.props.routeData.optionType;var query = this.props.location.query;var token = (0, _get2.default)(this.props, 'initialValues.access_token');if (token) {this.props.canCreateStaff(token);this.props.getAgencyInfo(token);}if (this.props.currentView !== view) {this.props.switchAccountView({ view: view });}if (query.code) {this.props.authenticateWithCode(query.code);}if (!this.props.userData.data && !query.code) {this.props.openAuthenticationModal({ selectedTab: _constants.userAuthenticationTabs.SIGN_IN });}};EditProfilePage.prototype.componentWillUnmount = function componentWillUnmount() {this.props.cleanAssets();};EditProfilePage.prototype.

  render = function render() {var _cx2;
    var token = (0, _get2.default)(this.props, 'userData.data.access_token') || (0, _get2.default)(this.props, 'userData.access_token');
    if (!token) {
      return null;
    }

    var titleKey = this.getTitleByRoute();

    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(
          styles.editProfile, (_cx2 = {}, _cx2[
          styles.formWrapper] = this.props.currentView === _constants.myAccountViews.MY_ACCOUNT, _cx2)) },

        _react2.default.createElement(_components.NotificationNoCompany, null),
        _react2.default.createElement(_reactHelmet2.default, {
          titleTemplate: this.props.translate('title', 'titleTemplate')(),
          title: this.props.translate('header', titleKey)(),
          meta: [{ property: 'og:title', content: 'OnMap | ' + this.props.translate('header', titleKey) }] }),

        this.props.isMobile ? this.renderMobilePage() : this.renderDesktopPage(),
        _react2.default.createElement(_WhatsAppWidget2.default, { translate: this.props.translate })));


  };return EditProfilePage;}(_react.Component);


var scrollToFirstError = function scrollToFirstError(errors) {
  var errorFields = Object.keys(errors);
  _reactScroll.scroller.scrollTo(errorFields[0], {
    duration: 500,
    smooth: true,
    containerSelector: '#app',
    containerId: 'app',
    offset: -95 });

};

var validate = function validate(values) {
  var errors = {};

  if (!values.display_name || !values.display_name.length) {
    errors.display_name = 'emptyField';
  }var

  isAgent = values.is_agent,agentData = values.agent_data;

  if (isAgent && (
  !agentData ||
  !agentData.license_number ||
  agentData.license_number && agentData.license_number.length < 4))
  {
    errors.agent_data = {
      license_number: 'emptyField' };

  }

  if (isAgent && (!agentData || !agentData.company_name)) {
    errors.agent_data = {
      company_name: 'emptyField' };

  }
  if (!(0, _validate.emailRegexValidation)(values.email)) {
    errors.email = 'wrongEmail';
  }

  return errors;
};

var registerNewField = function registerNewField(name) {return (0, _reduxForm.registerField)('editProfileForm', name, 'Field');};
var changeValue = function changeValue(_ref3) {var name = _ref3.name,value = _ref3.value;return (0, _reduxForm.change)('editProfileForm', name, value);};

EditProfilePage.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  openAuthenticationModal: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func,
  initialValues: _propTypes2.default.object,
  userData: _propTypes2.default.object,
  userDataError: _propTypes2.default.object,
  editUserProfile: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  isMessageModalOpen: _propTypes2.default.bool,
  registerNewField: _propTypes2.default.func,
  changeValue: _propTypes2.default.func,
  reset: _propTypes2.default.func,
  logOut: _propTypes2.default.func,
  clearUserPropertiesData: _propTypes2.default.func,
  clearFavorites: _propTypes2.default.func,
  clearStoreNotes: _propTypes2.default.func,
  loadFavorites: _propTypes2.default.func,
  toggleFavorite: _propTypes2.default.func,
  addPropertyNote: _propTypes2.default.func,
  openDetailsPopup: _propTypes2.default.func,
  setFavoritesListState: _propTypes2.default.func,
  isRealEstate: _propTypes2.default.bool,
  // isRtl: PropTypes.bool, TODO Uncomment for favorites
  dirty: _propTypes2.default.bool,
  isCanCreateStaff: _propTypes2.default.bool,
  phoneNumberVerified: _propTypes2.default.bool,
  isNative: _propTypes2.default.bool,
  changeAssetsTags: _propTypes2.default.func,
  cleanAssets: _propTypes2.default.func,
  addAssetToDelete: _propTypes2.default.func,
  addAssetToUnsuspend: _propTypes2.default.func,
  authenticateWithCode: _propTypes2.default.func,
  location: _propTypes2.default.object,
  routeData: _propTypes2.default.object,
  currentView: _propTypes2.default.string,
  switchAccountView: _propTypes2.default.func,
  updateVerification: _propTypes2.default.func,
  canCreateStaff: _propTypes2.default.func,
  clearSearchData: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  getAgencyInfo: _propTypes2.default.func,
  agencyInfo: _propTypes2.default.object };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    currentView: state.myAccount.currentView,
    userData: state.userAuthentication,
    agencyInfo: state.userAuthentication.agencyInfo,
    isNative: state.native.isNative,
    userDataError: state.userAuthentication.error,
    isCanCreateStaff: state.userAuthentication.isCanCreateStaff,
    favoriteProperties: state.favoriteProperties,
    isMessageModalOpen: state.messageModal.isMessageModalOpen,
    initialValues: state.userAuthentication.data ? Object.assign({},

    state.userAuthentication.data, {
      phone_number: state.userAuthentication.data.phone_number ?
      (0, _formatPhoneNumber.formatPhoneNumber)((0, _formatPhoneNumber.clearPhoneNumber)(state.userAuthentication.data.phone_number)) :
      null }) :

    null,
    isRealEstate: selector(state, 'is_agent'),
    phoneNumberVerified: state.phoneSmsVerification.phoneNumberSent && state.phoneSmsVerification.codeIsValid };};


var mapDispatchToProps = {
  openAuthenticationModal: _userAuthentication.openAuthenticationModal,
  editUserProfile: _userAuthentication.editUserProfile,
  openMessageModal: _messageModal.openMessageModal,
  registerNewField: registerNewField,
  changeValue: changeValue,
  logOut: _userAuthentication.logOut,
  hideMessageModal: _messageModal.hideMessageModal,
  clearUserPropertiesData: _manageProperties.clearUserPropertiesData,
  clearFavorites: _favoriteProperties.clearFavorites,
  clearStoreNotes: _propertyNotes.clearStoreNotes,
  setFavoritesListState: _favoriteProperties.setFavoritesListState,
  loadFavorites: _favoriteProperties.loadFavorites,
  openDetailsPopup: _propertyDetails.openDetailsPopup,
  toggleFavorite: _favoriteProperties.toggleFavorite,
  addPropertyNote: _propertyNotes.addPropertyNote,
  changeAssetsTags: _assetsToDelete.changeAssetsTags,
  cleanAssets: _assetsToDelete.cleanAssets,
  addAssetToDelete: _assetsToDelete.addAssetToDelete,
  addAssetToUnsuspend: _assetsToDelete.addAssetToUnsuspend,
  switchAccountView: _myAccount.switchAccountView,
  updateVerification: _userAuthentication.updateVerification,
  authenticateWithCode: _userAuthentication.authenticateWithCode,
  clearSearchData: _saveSearchLocation.clearSearchData,
  canCreateStaff: _userAuthentication.canCreateStaff,
  getAgencyInfo: _userAuthentication.getAgencyInfo };exports.default =


(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps),
(0, _reduxForm.reduxForm)({
  form: 'editProfileForm',
  validate: validate,
  onSubmitFail: function onSubmitFail(errors) {return scrollToFirstError(errors);} }))(

EditProfilePage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/EditProfilePage/EditProfilePage.js
// module id = 3044
// module chunks = 0